<template>
  <div id="app">
    <Topback/>
    <transition :name="transitionName" v-if="$route.meta.index && $route.meta.index>0">
      <router-view/>
    </transition>
    <router-view v-else/>
  </div>
</template>

<script>
  import Topback from './components/main/topback'
  import { isPc } from './util/common'
  export default {
    name: 'App',
    components: {
      Topback
    },
    data(){
      return {
        transitionName:''
      }
    },
    mounted(){

    },
    watch: {
      $route(to,from){
        if(to.meta.index > from.meta.index){
          this.transitionName = 'slide-left';
        }else{
          this.transitionName = 'slide-right';
        }
      }
    }
  }
</script>

<style>
  html,body,#app{
    margin:0;
    padding:0;
    overflow-x: hidden;
  }
  .slide-right-enter-active,.slide-right-leave-active,.slide-left-enter-active,.slide-right-leave-active {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
  }
  .slide-right-enter {
    opacity: 0.5;
    transform: translate3d(-80%,0,0);
  }
  .slide-right-leave-active {
    opacity: 0.5;
    transform: translate3d(80%,0,0);
  }
  .slide-left-enter {
    opacity: 0.5;
    transform: translate3d(80%,0,0);
  }
  .slide-left-leave-active {
    opacity: 0.5;
    transform: translate3d(-80%,0,0);
  }
  .el-upload {
    display:block;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue